module.exports = __webpack_public_path__ + "static/media/chipasticks_semillas.eee599aa.png";